import { Component, Input } from '@angular/core';

@Component({
  selector: 'bs-drawing-icon',
  imports: [],
  template: `
  <svg id="project-icon" [style.width.px]="width" [style.height.px]="height" [style.fill]="iconFill" [style.stroke]="iconFill" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
    <rect x="3.822" y="3.6" width="64.8" height="64.8" rx="3.6" ry="3.6" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="3.822" y1="53.4" x2="68.622" y2="53.4" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="3.822" y1="61.556" x2="41.222" y2="61.556" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="41.222" y1="68.4" x2="41.222" y2="53.4" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="29" y1="68.4" x2="29" y2="53.4" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="46.883" y1="60.9" x2="61.917" y2="60.9" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <path d="M19.866,19.597v16.967c0,.514.274.99.72,1.247l14.694,8.483c.446.257.994.257,1.44,0l14.694-8.483c.446-.257.72-.733.72-1.247v-16.967c0-.514-.274-.99-.72-1.247l-14.694-8.483c-.446-.257-.994-.257-1.44,0l-14.694,8.483c-.446.257-.72.733-.72,1.247Z" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="36" y1="28.08" x2="36" y2="46.08" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="36" y1="28.08" x2="51.588" y2="19.08" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="36" y1="28.08" x2="20.412" y2="19.08" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="36" y1="10.081" x2="36" y2="13.081" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="36" y1="17.081" x2="36" y2="23.08" style="fill: none; stroke-dasharray: 4 4; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="36" y1="25.08" x2="36" y2="28.08" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="51.588" y1="37.08" x2="48.99" y2="35.58" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="45.526" y1="33.58" x2="40.33" y2="30.58" style="fill: none; stroke-dasharray: 4 4; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="38.598" y1="29.58" x2="36" y2="28.08" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="20.412" y1="37.08" x2="23.01" y2="35.58" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="26.474" y1="33.58" x2="31.67" y2="30.58" style="fill: none; stroke-dasharray: 4 4; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="33.402" y1="29.58" x2="36" y2="28.08" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
  </svg>
  `,
  styles: `
    .icon-fill {
      fill: var(--p-bs-icon-color);
    }`,
  standalone: true
})
export class BsDrawingIconComponent {
  @Input() width: number = 30;
  @Input() height: number = 30;
  @Input() iconFill: string = 'var(--p-bs-icon-color)';
}
